export default __webpack_public_path__ + "static/media/logo-white.ee32a605.svg";